import { render, staticRenderFns } from "./OsobaEdit.vue?vue&type=template&id=626d2211&scoped=true&"
import script from "./OsobaEdit.vue?vue&type=script&lang=js&"
export * from "./OsobaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626d2211",
  null
  
)

export default component.exports